module.exports = __webpack_public_path__ + "img/t1-teal.b7d5a6b5.png";